import { WITHDRAW_STATE, WITHDRAW_CANCEL_REASON, ENUM_ASTROPAY_STATUS, WITHDRAW_WARNING } from './enums';
export enum ENUM_PIX_TYPES {
  email = 'email',
  cpf = 'cpf',
  phone = 'phone',
  random = 'random',
}
import {
  CURRENCY,
  FIAT_CODE,
  IAddress,
  IBet,
  ICryptoConfirmedTransaction,
  ITokenConfirmedTransaction,
  IWallet,
  WALLET_CODE,
} from '../interfaces';
import { IPaymentMethod } from './deposit.interfaces';
import { IPixKey, IUser } from './user.interfaces';
export enum ACCOUNT_MOVEMENT_TYPES {
  BET,
  BET_REMOVED, //1 no used
  BONUS,
  DEPOSIT,
  PRIZE, // 4 no used
  REFUND, // 5 no used
  WITHDRAW, // 6
  ROLLBACK, // 7 no used
  WITHDRAW_REMOVED, // 8 no used
  EXCHANGE,
  REFERRAL, //10 no used
  AFFILIATE, // 11 no used
  TICKET, // 12 no used
  DRAW_USER_BETS, //13
  GAME,
  BONUS_REWARD, // 15 no used
  SPORTS_BET,
  PLAYER_REWARD,
  MOVS_STORED, //18 es para movs guardados en account_movements_store
  RPP_CONVERTED, // 19
  LUCKY_CELLS_FIAT, // 20
}
export interface IWaletTransactions {
  movements: IAccountMovement[];
  wallet: WALLET_CODE;
  offset: number;
  total: number;
}
export interface IWalletBalance {
  balance: number;
  wallet: IWallet;
  loading?: boolean;
}
export interface IFiat {
  code: FIAT_CODE;
  name: string;
  enabled: boolean;
}
export interface IMovementsByCurrency {
  data: IAccountMovement[];
  code: WALLET_CODE;
  total: number;
}
export interface ICryptoDeposit {
  user_id: string;
  wallet: WALLET_CODE;
  amount: number;
  address: IAddress;
  transaction: ICryptoConfirmedTransaction | ITokenConfirmedTransaction;
  idempotencyKey: string;
}
export interface IAccountMovement {
  _id?: string;
  type: ACCOUNT_MOVEMENT_TYPES;
  user_id: string;
  amount: number;

  currency: CURRENCY;
  timestamp: number;

  deposit?: Partial<ICryptoDeposit>;

  deposit_id?: string;
  withdraw_id?: string;
  drawUserBets_id?: string;
  gameSession_id?: string;
  sportSession_id?: string;
  rpp_id?: string;
  bet_id?: string;
  ticket_id?: string;
  exchange_id?: string;
  promotionCode_id?: string;
  bonusReward_id?: string;
  playerReward_id?: string;
  luckyCellsGame_id?: string;
  monthlyReferralCommision_id?: string;
  bet?: IBet;
  bonusDesc?: string;
  acum?: number;
  acum_formatted?: string;
  date_formatted?: string;
  amount_formatted?: string;
  desc_formatted?: string;
  desc?: string;
  icon?: string;
  show?: boolean;
  draw?: string;
  accumulate?: number;

  amount_removed?: number;
  amount_prev?: number;
}
export interface IBalance {
  currency: CURRENCY | ICurrency;
  equity: number;
}
export interface ICurrency {
  _id: string;
  currency: CURRENCY;
  _currency: string;
  symbol?: string;
  selected?: boolean;
  balance?: number;
  pt: string;
  en: string;
  es: string;
  background: string;
  risk: number;
  min_deposit: number;
  min_withdraw: number;
  type: 'fiat' | 'crypto';
  cryptoBase: string;
  ratio: number;
  exchangeMargin: number;
  available: boolean;
}

export interface IWithdraw {
  _id?: string;
  amount: number;
  user_id: string;
  state: WITHDRAW_STATE;
  currency: CURRENCY;
  note?: string;
  timestamp: number;
  timestamp_settled?: number;
  balance?: any;
  user?: Partial<IUser>;
  cancelReason?: WITHDRAW_CANCEL_REASON;
  country: string;
  provider?: IPaymentMethod;
  transaction?: IAstropayCashoutResponse | IWithdrawTransaction | IWithdrawGnResponse;
  pixKey?: IPixKey;
  warning?: WITHDRAW_WARNING;
  acceptCommission?: boolean;
  address?: string;
}
export interface IAstropayCashoutResponse {
  status: ENUM_ASTROPAY_STATUS;
  cashout_id: string;
  merchant_cashout_id: string;
  error?: any;
}
export interface IWithdrawTransaction {
  status: WITHDRAW_STATE;
  process?: IWithdrawGnResponse;
}
export interface IWithdrawGnResponse {
  e2eId?: string;
  endToEndId?: string;
  valor: string;
  horario: { solicitacao: Date };
  status: WITHDRAW_STATUS_GN;
}
export enum WITHDRAW_STATUS_GN {
  EM_PROCESSAMENTO = 'EM_PROCESSAMENTO',
  REALIZADO = 'REALIZADO',
  NAO_REALIZADO = 'NAO_REALIZADO',
  DEVOLVIDO = 'DEVOLVIDO',
  // CHAVE_INVALIDA = 'CHAVE_INVALIDA',
}
export interface IBalancesList {
  balances_fiat: IWalletBalance[];
  balances_crypto: IWalletBalance[];
  balances_token: IWalletBalance[];
  balances_crypto_show: IWalletBalance[];
  wallet: IWallet;
  wallets: IWallet[];
  all: boolean;
}
